import createNamespaceContext from './helper/createNamespaceContext';
export const RECENT_WORK_CONTEXT = 'RecentWorkCtx';
export const RecentWorkAnalyticsContext = createNamespaceContext(RECENT_WORK_CONTEXT, 'RecentWorkAnalyticsContext');